import {Routes} from '@angular/router';
import {HomeComponent} from './components/pages/home/home.component';
import {AuthGuardService} from './services/auth-guard/auth-guard.service';
import {UserListComponent} from './components/pages/users/user-list/user-list.component';
import {LoginComponent} from './components/pages/login/login.component';
import {PartnerListComponent} from './components/pages/partners/partner-list/partner-list.component';
import {
  LandingPageListComponent
} from './components/pages/promotion-tools/landing-page/landing-page-list/landing-page-list.component';
import {PartnerTabComponent} from './components/pages/partners/partner-tab/partner-tab.component';
import {PartnerLinkComponent} from './components/pages/partners/partner-link/partner-link/partner-link.component';
import {
  ActivityFeedComponent
} from './components/pages/partners/partner-activity-feed/activity-feed/activity-feed.component';
import {OfferListComponent} from './components/pages/configuration/offer/offer-list/offer-list.component';
import {
  AdvertiserListComponent
} from './components/pages/configuration/advertiser/advertiser-list/advertiser-list.component';
import {
  AdvertiserFormComponent
} from './components/pages/configuration/advertiser/advertiser-form/advertiser-form.component';
import {OfferFormComponent} from './components/pages/configuration/offer/offer-form/offer-form.component';
import {ProductListComponent} from './components/pages/configuration/product/product-list/product-list.component';
import {ProductFormComponent} from './components/pages/configuration/product/product-form/product-form.component';
import {
  LandingPageFormComponent
} from './components/pages/promotion-tools/landing-page/landing-page-form/landing-page-form.component';
import {PartnerCreateFormComponent} from './components/pages/partners/partner-form/partner-create-form.component';
import {OfferTabComponent} from './components/pages/configuration/offer/offer-tab/offer-tab.component';
import {OfferGoalListComponent} from './components/pages/configuration/offer/offer-goal-list/offer-goal-list.component';
import {GoalListComponent} from './components/pages/configuration/goal/goal-list/goal-list.component';
import {GoalFormComponent} from './components/pages/configuration/goal/goal-form/goal-form.component';
import {ClickLogComponent} from './components/pages/system/click-log/click-log.component';
import {ConversionLogComponent} from './components/pages/system/conversion-log/conversion-log.component';
import {ActivityLogComponent} from './components/pages/users/activity-log/activity-log.component';
import {UserFormComponent} from './components/pages/users/user-form/user-form.component';
import {SiteConfigListComponent} from './components/pages/site/site-config/site-config-list/site-config-list.component';
import {
  PartnerSiteConfigListComponent
} from './components/pages/partners/partner-site-config-list/partner-site-config-list.component';
import {
  PartnerAccountManagementComponent
} from './components/pages/partners/partner-account-management/partner-account-management.component';
import {AffiliatePaymentComponent} from './components/pages/accounting/affiliate-payment/affiliate-payment.component';
import {AdvertiserReportComponent} from './components/pages/accounting/advertiser-report/advertiser-report.component';
import {AffiliateReportComponent} from './components/pages/accounting/affiliate-report/affiliate-report.component';
import {CurrentUserFormComponent} from './components/pages/users/current-user-form/current-user-form.component';
import {
  CustomPayoutListComponent
} from './components/pages/partners/partner-custom-payout/custom-payout-list/custom-payout-list.component';
import {
  CustomPayoutFormComponent
} from './components/pages/partners/partner-custom-payout/custom-payout-form/custom-payout-form.component';
import {
  PartnerTrackingTabComponent
} from './components/pages/partners/partner-tracking/partner-tracking-tab/partner-tracking-tab.component';
import {
  PartnerPostbackListComponent
} from './components/pages/partners/partner-tracking/partner-postback/partner-postback-list/partner-postback-list.component';
import {
  PartnerPostbackFormComponent
} from './components/pages/partners/partner-tracking/partner-postback/partner-postback-form/partner-postback-form.component';
import {PartnerPaymentComponent} from './components/pages/partners/partner-payment/partner-payment.component';
import {PartnerToolsComponent} from './components/pages/partners/partner-tools/partner-tools.component';
import {PartnerOfferComponent} from './components/pages/partners/partner-offer/partner-offer.component';
import {SiteListComponent} from './components/pages/site/site/site-list/site-list.component';
import {SiteFormComponent} from './components/pages/site/site/site-form/site-form.component';
import {
  TranslationDomainListComponent
} from './components/pages/translation/translation-domain-list/translation-domain-list.component';
import {
  TranslationMessageListComponent
} from './components/pages/translation/translation-message-list/translation-message-list.component';
import {DetailedComponent} from './components/pages/stats/detailed/detailed.component';
import {LeadLogComponent} from './components/pages/system/lead-log/lead-log.component';
import {NewsFormComponent} from './components/pages/configuration/news/news-form/news-form.component';
import {NewsListComponent} from './components/pages/configuration/news/news-list/news-list.component';
import {
  TranslationIntegrationComponent
} from './components/pages/translation/translation-integration/translation-integration.component';
import {AsyncCommandComponent} from './components/pages/system/async-command/async-command.component';
import {RoiComponent} from './components/pages/stats/roi/roi.component';
import {HourlyComponent} from './components/pages/stats/hourly/hourly.component';
import {FunnelsComponent} from './components/pages/stats/funnels/funnels.component';
import {
  ProductPriorityListComponent
} from './components/pages/configuration/product-priority/product-priority-list/product-priority-list.component';
import {
  ProductPriorityFormComponent
} from './components/pages/configuration/product-priority/product-priority-form/product-priority-form.component';
import {
  ConversionEventLogComponent
} from './components/pages/system/conversion-event-log/conversion-event-log.component';
import {LanguageListComponent} from './components/pages/translation/language/language-list/language-list.component';
import {CostLogComponent} from './components/pages/system/cost-log/cost-log.component';
import {BotRuleListComponent} from './components/pages/site/bot-rule/bot-rule-list/bot-rule-list.component';
import {BotRuleFormComponent} from './components/pages/site/bot-rule/bot-rule-form/bot-rule-form.component';
import {IpRuleListComponent} from './components/pages/configuration/ip-rule/ip-rule-list/ip-rule-list.component';
import {IpRuleFormComponent} from './components/pages/configuration/ip-rule/ip-rule-form/ip-rule-form.component';
import {
  StaticPageListComponent
} from './components/pages/promotion-tools/cms/static-page/static-page-list/static-page-list.component';
import {
  StaticPageFormComponent
} from './components/pages/promotion-tools/cms/static-page/static-page-form/static-page-form.component';
import {
  BotPromptListComponent
} from './components/pages/translation/bot-prompt/bot-prompt-list/bot-prompt-list.component';
import {
  BotPromptFormComponent
} from './components/pages/translation/bot-prompt/bot-prompt-form/bot-prompt-form.component';
import {WidgetListComponent} from './components/pages/promotion-tools/cms/widget/widget-list/widget-list.component';
import {WidgetFormComponent} from './components/pages/promotion-tools/cms/widget/widget-form/widget-form.component';
import {WidgetAddComponent} from './components/pages/promotion-tools/cms/widget/widget-add/widget-add.component';
import {FunnelListComponent} from './components/pages/promotion-tools/cms/funnel/funnel-list/funnel-list.component';
import {FunnelFormComponent} from './components/pages/promotion-tools/cms/funnel/funnel-form/funnel-form.component';
import {
  AvailableDomainListComponent
} from './components/pages/configuration/available-domain/available-domain-list/available-domain-list.component';
import {
  AvailableDomainFormComponent
} from './components/pages/configuration/available-domain/available-domain-form/available-domain-form.component';
import {
  ContentLibraryListComponent
} from './components/pages/promotion-tools/cms/content-library/content-library-list/content-library-list.component';
import {
  ContentLibraryAddComponent
} from './components/pages/promotion-tools/cms/content-library/content-library-add/content-library-add.component';
import {
  ContentLibraryFormComponent
} from './components/pages/promotion-tools/cms/content-library/content-library-form/content-library-form.component';
import {
  LandingPagePoolListComponent
} from './components/pages/promotion-tools/landing-page/landing-page-pool-list/landing-page-pool-list.component';
import {
  LandingPagePoolFormComponent
} from './components/pages/promotion-tools/landing-page/landing-page-pool-form/landing-page-pool-form.component';
import {PrepingToolComponent} from './components/pages/system/preping-tool/preping-tool.component';
import {DecryptToolComponent} from './components/pages/system/decrypt-tool/decrypt-tool.component';
import {
  TranslationErrorListComponent
} from './components/pages/translation/translation-error/translation-error-list/translation-error-list.component';
import {
  MicrosoftAdsAuthRedirectComponent
} from './components/pages/partners/partner-account-management/microsoft-ads-auth-redirect/microsoft-ads-auth-redirect.component';
import {
  RedirectRuleListComponent
} from './components/pages/promotion-tools/redirect-rule/redirect-rule-list/redirect-rule-list.component';
import {
  RedirectRuleFormComponent
} from './components/pages/promotion-tools/redirect-rule/redirect-rule-form/redirect-rule-form.component';

export const routes: Routes = [
  {path: 'login', component: LoginComponent},

  // Home
  {path: '', component: HomeComponent, canActivate: [AuthGuardService]},

  // Partners
  {path: 'partners', component: PartnerListComponent, canActivate: [AuthGuardService]},
  {
    path: 'partners/activity',
    component: ActivityFeedComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'partners/add/:type',
    component: PartnerCreateFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'partners/:partnerId',
    component: PartnerTabComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'payment',
        component: PartnerPaymentComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'activity',
        component: ActivityFeedComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'account-management',
        component: PartnerAccountManagementComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'behavior-config',
        component: PartnerSiteConfigListComponent,
        canActivate: [AuthGuardService]
      },
      {path: 'links', component: PartnerLinkComponent, canActivate: [AuthGuardService]},
      {path: 'tools', component: PartnerToolsComponent, canActivate: [AuthGuardService]},
      {path: 'offers', component: PartnerOfferComponent, canActivate: [AuthGuardService]},
      {path: 'custom-payouts', component: CustomPayoutListComponent, canActivate: [AuthGuardService]},
      {path: 'custom-payouts/add', component: CustomPayoutFormComponent, canActivate: [AuthGuardService]},
      {path: 'custom-payouts/:id', component: CustomPayoutFormComponent, canActivate: [AuthGuardService]},
      {
        path: 'tracking',
        component: PartnerTrackingTabComponent,
        canActivate: [AuthGuardService],
        children: [
          {
            path: 'postback',
            component: PartnerPostbackListComponent,
            canActivate: [AuthGuardService]
          },
          {
            path: 'postback/add',
            component: PartnerPostbackFormComponent,
            canActivate: [AuthGuardService]
          },
          {
            path: 'postback/:id',
            component: PartnerPostbackFormComponent,
            canActivate: [AuthGuardService]
          }
        ]
      }
    ]
  },

  // Stats
  {
    path: 'stats/detailed',
    component: DetailedComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'stats/hourly',
    component: HourlyComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'stats/funnels',
    component: FunnelsComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'stats/roi',
    component: RoiComponent,
    canActivate: [AuthGuardService]
  },

  // Promotions tools
  {
    path: 'promotion-tools/landing-pages',
    component: LandingPageListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/landing-pages/:id',
    component: LandingPageFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/landing-pages-pools',
    component: LandingPagePoolListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/landing-pages-pools/:id',
    component: LandingPagePoolFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/cms/static-pages',
    component: StaticPageListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/cms/static-pages/:id',
    component: StaticPageFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/cms/widgets',
    component: WidgetListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/cms/widgets/add',
    component: WidgetAddComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/cms/widgets/:id',
    component: WidgetFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/cms/funnels',
    component: FunnelListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/cms/funnels/:id',
    component: FunnelFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/cms/content-library',
    component: ContentLibraryListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/cms/content-library/add',
    component: ContentLibraryAddComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/cms/content-library/:id',
    component: ContentLibraryFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/redirect-rules',
    component: RedirectRuleListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotion-tools/redirect-rules/:id',
    component: RedirectRuleFormComponent,
    canActivate: [AuthGuardService]
  },

  // Configuration
  {
    path: 'configuration/advertisers',
    component: AdvertiserListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/advertisers/:id',
    component: AdvertiserFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/offers',
    component: OfferListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/offers/add',
    component: OfferFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/offers/:id', component: OfferTabComponent, canActivate: [AuthGuardService],
    children: [
      {path: '', component: OfferFormComponent, canActivate: [AuthGuardService]},
      {path: 'goals', component: OfferGoalListComponent, canActivate: [AuthGuardService]},
    ]
  },
  {
    path: 'configuration/products',
    component: ProductListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/products/:id',
    component: ProductFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/products-priority',
    component: ProductPriorityListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/products-priority/:id',
    component: ProductPriorityFormComponent,
    canActivate: [AuthGuardService]
  },
  {path: 'configuration/goals', component: GoalListComponent, canActivate: [AuthGuardService]},
  {
    path: 'configuration/goals/:id',
    component: GoalFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/news',
    component: NewsListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/news/:id',
    component: NewsFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/ip-rules',
    component: IpRuleListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/ip-rules/:id',
    component: IpRuleFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/domain',
    component: AvailableDomainListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/domain/:id',
    component: AvailableDomainFormComponent,
    canActivate: [AuthGuardService]
  },

  // Site
  {
    path: 'site/sites/:id',
    component: SiteFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'site/sites',
    component: SiteListComponent,
    canActivate: [AuthGuardService]
  }, {
    path: 'site/behavior-config',
    component: SiteConfigListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'site/bot-rules',
    component: BotRuleListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'site/bot-rules/:id',
    component: BotRuleFormComponent,
    canActivate: [AuthGuardService]
  },

  // Translation
  {
    path: 'translation/translation-integration',
    component: TranslationIntegrationComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'translation/translations',
    component: TranslationDomainListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'translation/translations/:id',
    component: TranslationMessageListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'translation/bot-prompts',
    component: BotPromptListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'translation/bot-prompts/:id',
    component: BotPromptFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'translation/languages',
    component: LanguageListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'translation/errors',
    component: TranslationErrorListComponent,
    canActivate: [AuthGuardService]
  },

  // Users
  {path: 'users/users', component: UserListComponent, canActivate: [AuthGuardService]},
  {path: 'users/users/current', component: CurrentUserFormComponent, canActivate: [AuthGuardService]},
  {path: 'users/users/:id', component: UserFormComponent, canActivate: [AuthGuardService]},
  {
    path: 'users/activity-log',
    component: ActivityLogComponent,
    canActivate: [AuthGuardService]
  },

  // System
  {
    path: 'system/click-log',
    component: ClickLogComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'system/conversion-log',
    component: ConversionLogComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'system/lead-log',
    component: LeadLogComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'system/async-command',
    component: AsyncCommandComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'system/conversion-event-log',
    component: ConversionEventLogComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'system/cost-log',
    component: CostLogComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'system/preping-tool',
    component: PrepingToolComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'system/decrypt-tool',
    component: DecryptToolComponent,
    canActivate: [AuthGuardService]
  },

  // Accounting
  {
    path: 'accounting/affiliate',
    component: AffiliatePaymentComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'accounting/advertiser-report',
    component: AdvertiserReportComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'accounting/affiliate-report',
    component: AffiliateReportComponent,
    canActivate: [AuthGuardService]
  },

  // Microsoft Ads OAuth Redirect
  {
    path: 'microsoft-ads-auth-redirect',
    component: MicrosoftAdsAuthRedirectComponent,
    canActivate: [AuthGuardService]
  },

  // Fallback
  {path: '**', redirectTo: ''}
];
